<div class="md-modal">
  <div class="md-body">
    <h3>{{ question }}</h3>
    <p class="text-center">
      {{'SHARED.confirmDeleteMultiple.title' | translate}}
    </p>
    @if (showNotifyClientOption) {
      <div class="text-center custom-control custom-checkbox">
        <input [(ngModel)]="notifyClient" type="checkbox" class="custom-control-input" id="notifyClient" />
        <label class="custom-control-label" for="notifyClient">
          {{ 'SHARED.createBookingModal.notifyClient' | translate }}
        </label>
      </div>
    }
  </div>
  <div class="md-actions">

    <button class="btn btn-md btn-primary mr-2" [disabled]="submitted" (click)="close(false, false)">{{'GENERAL.no' | translate}}</button>
    <!-- <button class="btn btn-success mr-2" (click)="close(true, false)">{{'SHARED.confirmDeleteMultiple.deleteOnlyThis' | translate}}</button> -->
    <button class="btn btn-md btn-success mr-2" [disabled]="submitted" (click)="close(false, true)">{{'SHARED.confirmDeleteMultiple.deleteAll' | translate}}</button>
  </div>
</div>
